module.exports = __webpack_public_path__ + "media/images/jlp-features-job-search-a5d2d2f576c8030e676db4e80b2aae41.svg";